var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPieLogoSymbol = function SvgPieLogoSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.42 470",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.42 102.12C394 45.31 346.61 0 289.8 0H104.69C48.31 0 1.09 44.6 0 101a103.07 103.07 0 0 0 103 104.92h82.7a6 6 0 0 1 2.4 11.42L61.31 272.91A103.09 103.09 0 0 0 0 367.83C.43 424.65 47.79 470 104.62 470H148c57.23 0 104.88-45.9 104.79-103.13a103.11 103.11 0 0 0-64.48-95.31 5.94 5.94 0 0 1-.11-10.94l145-63.58a103.08 103.08 0 0 0 61.22-94.92Z",
    "data-name": "Layer 1"
  }))));
};
export default SvgPieLogoSymbol;